import {createWithEqualityFn as create} from "zustand/traditional";
import {createDocumentsSlice, DocumentsState} from "@/hooks/queries/stores/documentsStore";
import {createIntegrationsSlice, IntegrationsState} from "@/hooks/queries/stores/integrationsStore";
import {AgentStoreState, createAgentSlice} from "@/hooks/queries/stores/agentStore";
import {createTemplatesSlice, TemplatesStoreState} from "@/hooks/queries/stores/templatesStore";
import {ArtifactsStoreState, createArtifactsSlice} from "@/hooks/queries/stores/artifactsStore";
import {createUsersSlice, UsersStoreState} from "@/hooks/queries/stores/usersStore";
import {CommentsStoreState, createCommentsSlice} from "@/hooks/queries/stores/commentsStore";
import {AdminStoreState, createAdminSlice} from "@/hooks/queries/stores/adminStore";
import {createPulseSlice, PulseStoreState} from "@/hooks/queries/stores/pulseStore";
import {WorkLogStoreState, createWorkLogSlice} from "@/hooks/queries/stores/worklogStore";
import {TagsStoreState, createTagsSlice} from "@/hooks/queries/stores/tagsStore";
import {createJobsSlice, JobsStoreState} from "@/hooks/queries/stores/jobsStore";
import {createInlineCommentsSlice, InlineCommentsStoreState} from "@/hooks/queries/stores/inlineCommentsStore";
import {createSecretsSlice, SecretsStoreState} from "@/hooks/queries/stores/secretsStore";
import {ActivityStoreState, createActivitySlice} from "@/hooks/queries/stores/activityStore";
import {CatalogueStoreState, createCatalogueSlice} from "@/hooks/queries/stores/catalogueStore";
import {WorkspaceChatStoreState, createWorkspaceChatSlice} from "@/hooks/queries/stores/workspaceChatStore";
import {ChangesReportStoreState, createChangesReportSlice} from "@/hooks/queries/stores/changesReportStore";
import {TrendsStoreState, createTrendsSlice} from "@/hooks/queries/stores/trendsStore";
import {ReleasesStoreState, createReleasesSlice} from "@/hooks/queries/stores/releasesStore";
import {
  createWorkspaceMemoriesSlice,
  WorkspaceMemoriesStoreState,
} from "@/hooks/queries/stores/workspaceMemoriesStore";
import {createGoalsSlice, GoalsStoreState} from "@/hooks/queries/stores/goalsStore";
import {
  createEvidenceHydrationSlice,
  EvidenceHydrationStoreState,
} from "@/hooks/queries/stores/evidenceHydrationStore";
import {createDashboardsSlice, DashboardsStoreState} from "@/hooks/queries/stores/dashboardsStore";
import {
  createProjectSummariesSlice,
  ProjectSummariesStoreState,
} from "@/hooks/queries/stores/projectSummariesStore";

export const useBoundStore = create<
  DocumentsState & IntegrationsState & AgentStoreState & TemplatesStoreState & ArtifactsStoreState
  & UsersStoreState & CommentsStoreState & AdminStoreState & PulseStoreState & WorkLogStoreState & TagsStoreState
  & JobsStoreState & InlineCommentsStoreState & SecretsStoreState & ActivityStoreState & CatalogueStoreState
  & WorkspaceChatStoreState
  & ChangesReportStoreState
  & TrendsStoreState
  & ReleasesStoreState
  & WorkspaceMemoriesStoreState
  & GoalsStoreState
  & EvidenceHydrationStoreState
  & DashboardsStoreState
	& ProjectSummariesStoreState
	>()((...a) => ({
  ...createDocumentsSlice(...a),
  ...createIntegrationsSlice(...a),
  ...createAgentSlice(...a),
  ...createTemplatesSlice(...a),
  ...createArtifactsSlice(...a),
  ...createUsersSlice(...a),
  ...createCommentsSlice(...a),
  ...createAdminSlice(...a),
  ...createPulseSlice(...a),
  ...createWorkLogSlice(...a),
  ...createTagsSlice(...a),
  ...createJobsSlice(...a),
  ...createInlineCommentsSlice(...a),
  ...createSecretsSlice(...a),
  ...createActivitySlice(...a),
  ...createCatalogueSlice(...a),
  ...createWorkspaceChatSlice(...a),
  ...createChangesReportSlice(...a),
  ...createTrendsSlice(...a),
  ...createReleasesSlice(...a),
  ...createWorkspaceMemoriesSlice(...a),
  ...createGoalsSlice(...a),
  ...createEvidenceHydrationSlice(...a),
  ...createDashboardsSlice(...a),
  ...createProjectSummariesSlice(...a),
}))
